export const QueryKeyMapping = {
  FineSyncConfiguration: 'fineSyncConfiguration',
};
